import momentFormat from 'ember-moment/helpers/moment-format';
import { or } from 'ember-truth-helpers';

<template>
  {{momentFormat @value (or @settings.format 'L') allow-empty=true}}
</template>
